<form [formGroup]="PTWPermitForm" (ngSubmit)="submitDialog()" #myform="ngForm">
  <ara-side-nav class="inside-topnav"></ara-side-nav>
  <div class="section-wrapper right"><span class="mandatory-info">Fields
      marked with <span class="mandatory">*</span> are mandatory</span></div>
  <div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mobile-view">
      <div class="inner-wrapper">
        <div (click)="checkTrueForA()">
          <span class="section-title">Section A</span>
          <div><span class="section-sub-title  margin-right-20"> 1. Is the work within the Process Facility? </span>
            <label class="radio-inline">
              <input type="radio" value="true" id="amod" name="IsWithinFacilities" formControlName="IsWithinFacilities"
                (click)="isWithinFacilities = 1">Yes
            </label>
            <label class="radio-inline">
              <input type="radio" value="false" name="IsWithinFacilities" formControlName="IsWithinFacilities"
                (click)="isWithinFacilities = 0">No
            </label>
            <span class="error-msg-colour"
              *ngIf="myform.submitted && PTWPermitForm.get('IsWithinFacilities').hasError('required')">Please Select
              Yes Or No</span>
          </div><br>
          <div><span class="section-sub-title margin-right-20"> 2. Is the work within a Hydrocarbon Area?  </span>
            <label class="radio-inline">
              <input type="radio" value="true" name="IsHydrocarbonArea" formControlName="IsHydrocarbonArea"
                (click)="isHydrocarbonArea = 1">Yes
            </label>
            <label class="radio-inline">
              <input type="radio" value="false" name="IsHydrocarbonArea" formControlName="IsHydrocarbonArea"
                (click)="isHydrocarbonArea = 0">No
            </label>
            <span class="error-msg-colour"
              *ngIf="myform.submitted && PTWPermitForm.get('IsHydrocarbonArea').hasError('required')">Please Select
              Yes Or No</span>
          </div><br>
          <div><span class="section-sub-title margin-right-20"> 3. Is the work in/ on electrical installations?  </span>
            <label class="radio-inline">
              <input type="radio" value="true" name="IsElectricalInstallations"
                formControlName="IsElectricalInstallations" (click)="isElectricalInstallations = 1">Yes
            </label>
            <label class="radio-inline">
              <input type="radio" value="false" name="IsElectricalInstallations"
                formControlName="IsElectricalInstallations" (click)="isElectricalInstallations = 0">No
            </label>
            <span class="error-msg-colour"
              *ngIf="myform.submitted && PTWPermitForm.get('IsElectricalInstallations').hasError('required')">Please
              Select
              Yes Or No</span>
          </div><br>
          <div><span class="section-sub-title margin-right-20"> 4. Is the work in a confined space?  </span>
            <label class="radio-inline">
              <input type="radio" value="true" name="IsConfinedSpace" formControlName="IsConfinedSpace"
                (click)="isConfinedSpace = 1">Yes
            </label>
            <label class="radio-inline">
              <input type="radio" value="false" name="IsConfinedSpace" formControlName="IsConfinedSpace"
                (click)="isConfinedSpace = 0">No
            </label>
            <span class="error-msg-colour"
              *ngIf="myform.submitted && PTWPermitForm.get('IsConfinedSpace').hasError('required')">Please Select
              Yes Or No</span>
          </div><br>
          <div><span class="section-sub-title margin-right-20"> 5. Is a supplementary certificate required for the work? </span>
            <label class="radio-inline">
              <input type="radio" value="true" name="IsSupplementaryCertificate"
                formControlName="IsSupplementaryCertificate" (click)="isSupplementaryCertificate = 1">Yes
            </label>
            <label class="radio-inline">
              <input type="radio" value="false" name="IsSupplementaryCertificate"
                formControlName="IsSupplementaryCertificate" (click)="isSupplementaryCertificate = 0">No
            </label>
            <span class="error-msg-colour"
              *ngIf="myform.submitted && PTWPermitForm.get('IsSupplementaryCertificate').hasError('required')">Please
              Select
              Yes Or No</span>
          </div><br>
          <div><span class="section-sub-title margin-right-20"> 6. Is the work within Emergency Planning Zone of a critical source area?
              
            </span>
            <label class="radio-inline">
              <input type="radio" value="true" name="IsEmergencyPlanning" formControlName="IsEmergencyPlanning"
                (click)="isEmergencyPlanning = 1">Yes
            </label>
            <label class="radio-inline">
              <input type="radio" value="false" name="IsEmergencyPlanning" formControlName="IsEmergencyPlanning"
                (click)="isEmergencyPlanning = 0">No
            </label>
            <span class="error-msg-colour"
              *ngIf="myform.submitted && PTWPermitForm.get('IsEmergencyPlanning').hasError('required')">Please Select
              Yes Or No</span>
          </div><br>
        </div><br>
        <div (click)="checkFalseForB()">
          <div id="AddSectionB" [hidden]="IsHiddenB">
            <span class="section-title">Section B</span>
            <div><span class="section-sub-title margin-right-20"> 1. Is the work familiar to the work force? 
              </span>
              <label class="radio-inline">
                <input type="radio" value="true" name="IsWorkForce" formControlName="IsWorkForce"
                  (click)="isWorkForce = 1">Yes
              </label>
              <label class="radio-inline">
                <input type="radio" value="false" name="IsWorkForce" formControlName="IsWorkForce"
                  (click)="isWorkForce = 0">No
              </label>
              <span class="error-msg-colour"
                *ngIf="myform.submitted && PTWPermitForm.get('IsWorkForce').hasError('required')">Please Select
                Yes Or No</span>
            </div><br>
            <div><span class="section-sub-title margin-right-20"> 2. Is the work going to be undertaken by competent staff? 
              </span>
              <label class="radio-inline">
                <input type="radio" value="true" name="IsCompetentStaff" formControlName="IsCompetentStaff"
                  (click)="isCompetentStaff = 1">Yes
              </label>
              <label class="radio-inline">
                <input type="radio" value="false" name="IsCompetentStaff" formControlName="IsCompetentStaff"
                  (click)="isCompetentStaff = 0">No
              </label>
              <span class="error-msg-colour"
                *ngIf="myform.submitted && PTWPermitForm.get('IsCompetentStaff').hasError('required')">Please Select
                Yes Or No</span>
            </div><br>
            <div><span class="section-sub-title margin-right-20"> 3. Is there a written procedure for the work? 
              </span>
              <label class="radio-inline">
                <input type="radio" value="true" name="IsWrittenProcedure" formControlName="IsWrittenProcedure"
                  (click)="isWrittenProcedure = 1">Yes
              </label>
              <label class="radio-inline">
                <input type="radio" value="false" name="IsWrittenProcedure" formControlName="IsWrittenProcedure"
                  (click)="isWrittenProcedure = 0">No
              </label>
              <span class="error-msg-colour"
                *ngIf="myform.submitted && PTWPermitForm.get('IsWrittenProcedure').hasError('required')">Please Select
                Yes Or No</span>
            </div><br>
          </div>
        </div><br>
        <div [hidden]="IsHiddenC">
          <span class="section-title">Section C</span>
          <div><span class="section-sub-title margin-right-20"> 1. Job QHSSE Plan been written for the work </span>
            <label class="radio-inline">
              <input type="radio" value="true" (change)="decideButtonText()" name="IsPlanWritten"
                formControlName="IsPlanWritten">Yes
            </label>
            <label class="radio-inline">
              <input type="radio" value="false" (change)="decideButtonText()" name="IsPlanWritten"
                formControlName="IsPlanWritten">No
            </label>
            <span class="error-msg-colour"
              *ngIf="myform.submitted && PTWPermitForm.get('IsPlanWritten').hasError('required')">Please Select
              Yes Or No</span>
          </div><br>
          <div><span class="section-sub-title margin-right-20"> 2. Work Site Supervisor appointed for the work </span>
            <label class="radio-inline">
              <input type="radio" value="true" (change)="decideButtonText()" name="IsSupervisorAppointed"
                formControlName="IsSupervisorAppointed">Yes
            </label>
            <label class="radio-inline">
              <input type="radio" value="false" (change)="decideButtonText()" name="IsSupervisorAppointed"
                formControlName="IsSupervisorAppointed">No
            </label>
            <span class="error-msg-colour"
              *ngIf="myform.submitted && PTWPermitForm.get('IsSupervisorAppointed').hasError('required')">Please Select
              Yes Or No</span>
          </div><br>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <footer>
      <p-footer>
        <button type="submit" style="color:#fff" class="active-btn orange-btn button-excel">{{btnLabel}}</button>
      </p-footer>
    </footer>
  </div>
</form>
